export enum AdminAdminsTableColumnTitle {
  FirstName = "Ime",
  LastName = "Prezime",
  Role = "Rola",
  Email = "Email",
  Active = "Aktivan",
  Options = "",
}
